// Pure formatters for the prices table. Isolated from the component so the
// API-shape contract (null cells, per-month strings) is easy to reason about/test.

// formatMoney returns "<symbol><value>" or "—" for a missing price. null/undefined AND 0
// are treated as gaps (the spec makes 0 a missing-price sentinel; no real plan costs 0), so
// a stray 0 renders "—" rather than a misleading "$0".
export function formatMoney(symbol, value) {
  if (value === null || value === undefined || value === 0) return '—';
  return `${symbol}${value}`;
}

// Extra-session price keeps cents ($14.50), drops them for integers ($23), and shows — when empty.
export function formatSessionPrice(symbol, value) {
  if (value === null || value === undefined || value === 0) return '—';
  const str = Number.isInteger(value) ? String(value) : value.toFixed(2);
  return `${symbol}${str}`;
}

// cellHalf returns display strings for one offer-state half of a cell.
// perMonth is null (no line rendered) when the source per-month is absent (null/undefined/0).
export function cellHalf(symbol, total, perMonth) {
  const hasPerMonth = perMonth !== null && perMonth !== undefined && perMonth !== 0;
  return {
    total: formatMoney(symbol, total),
    perMonth: hasPerMonth ? `${formatMoney(symbol, perMonth)}/mo` : null
  };
}

// recordingLine renders what a paid recording grant adds to a term, e.g. "+AED69".
// null (no line) when the plan/currency has no recording price — never "+0".
export function recordingLine(symbol, value) {
  if (value === null || value === undefined || value === 0) return null;
  return `+${symbol}${value}`;
}
